"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Logger_1 = require("../../util/Logger");
var FieldArgs = (function () {
    function FieldArgs(aliasFor, entity, query, params, directive, includeIf) {
        this.aliasFor = aliasFor;
        this.directive = directive;
        this.entity = entity;
        this.params = params;
        this.query = query;
        this.includeIf = includeIf;
    }
    FieldArgs.isValid = function (args) {
        return typeof args === 'undefined' || (typeof args === 'object' && ((typeof args.aliasFor === 'undefined' || typeof args.aliasFor === 'string') &&
            (typeof args.directive === 'undefined' || typeof args.directive === 'string') &&
            (typeof args.entity === 'undefined' || typeof args.entity === 'function') &&
            (typeof args.params === 'undefined' ||
                typeof args.params === 'boolean' ||
                typeof args.params === 'object' ||
                typeof args.params === 'function') &&
            (typeof args.includeIf === 'undefined' || typeof args.includeIf === 'function') &&
            (typeof args.query === 'undefined' || typeof args.query === 'string')));
    };
    FieldArgs.parseArgs = function (args, thow) {
        if (thow === void 0) { thow = true; }
        if (thow && !FieldArgs.isValid(args)) {
            Logger_1.default.throw("arguments.field");
        }
        if (typeof args === 'undefined') {
            return new FieldArgs();
        }
        if (typeof args === 'object') {
            return new FieldArgs(args.aliasFor, args.entity, args.query, args.params, args.directive, args.includeIf);
        }
    };
    FieldArgs.prototype.isValid = function () {
        return FieldArgs.isValid(this);
    };
    return FieldArgs;
}());
exports.default = FieldArgs;
//# sourceMappingURL=FieldArgs.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/decorators/field/FieldArgs.js
// module id = 1451
// module chunks = 0